<template>
  <div>
    <div :class="button_class" tabindex="-1" onclick="page_subdomains.drop_down(this, event)">
      <span class="button-default__name" v-html="get_caption()"></span>
      <span class="button-default__delimiter"/>
    </div>

    <div :class="container_class">
      <div :class="wrapperr_class">
        <a v-for="option in options" :class="item_class" :data-value="option.value" v-on:click="set_val(option)">
          <div :class="item_text_class">{{ option.label }}</div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'dropdown-sub',
    props: {
      value: {},
      options: {type: Array, default:[]},

      button_class: {type: String, default: 'all-artists__button'},
      container_class: {type: String, default: 'all-artists__list-container'},
      wrapperr_class: {type: String, default: 'all-artists__list-wrapper'},
      item_class: {type: String, default: 'all-artists__dropdown-list__item'},
      item_text_class: {type: String, default: 'all-artists__dropdown-text'},

      /**
       * An optional callback function that is called each time the selected
       * value(s) change. When integrating with Vuex, use this callback to trigger
       * an action, rather than using :value.sync to retreive the selected value.
       * @type {Function}
       * @param {Object || String} val
       */
      onChange: {
        type: Function,
        default: function (val) {
          this.$emit('input', val)
        }
      },
    },

    methods: {
      get_caption(){
        if ( this.is_setcaption=='0' ) return this.placeholder;

        let caption=this.get_label();
        if ( caption.length===0 ) caption='<span style="color:#b3b3b3">'+this.placeholder+'</span>';

        return caption;
      },

      get_label() {
          let val_str='';
          if (typeof this.value === 'object') val_str=this.value.label;

        return val_str;
      },

      get_value() {
          let val_str='';
          if (typeof this.value === 'object') val_str=this.value.value;

          return val_str;
      },

      set_val(new_val){
        this.$emit('input', new_val);
        this.onChange ? this.onChange(new_val) : null;
      },
    }

  }
</script>



// WEBPACK FOOTER //
// src/sub/_common/components/lib/dropdownSub.vue